
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { QueryClient } from "@tanstack/react-query";

export function useScoreboardRealtime(kitId: string | undefined, queryClient: QueryClient) {
  useEffect(() => {
    if (!kitId) return;

    const channel = supabase
      .channel('scoreboard-changes')
      .on(
        'postgres_changes',
        { 
          event: 'UPDATE',  // We only need UPDATE since we're using upsert
          schema: 'public',
          table: 'scoreboard_states',
          filter: `kit_id=eq.${kitId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['scoreboard-state', kitId] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [kitId, queryClient]);
}
